<template>
  <div class="print-qr-page">
    <v-img alt="Logo" class="shrink mr-2 app print-logo" contain :src="logoimage" transition="scale-transition" />

    <v-sheet class="folded-corner print-panel">
      <v-container>
        <v-card elevation="0" class="print-card align-center pa-4 mx-auto">
          <header class="print-header">
            <h1>{{ "คิวอาร์โค้ดสำหรับผู้มาติดต่อ" }}</h1>
            <p>{{ "QR Code Visitors" }}</p>
            <v-divider class="print-divider"></v-divider>
            <span>{{ "*Please take a photo of the Qrcode" }}</span>
          </header>

          <section class="qr-stage">
            <v-card v-if="show" id="capture" elevation="0" class="qr-ticket">
              <div class="qr-tenant">{{ tenantName }}</div>
              <div class="qr-floor">{{ $t("message.Floor") }} : {{ floorName }}</div>
              <div class="qr-code-wrap">
                <qr-code :size="260" :text="Qrcode" error-level="L"></qr-code>
              </div>
              <div class="qr-date">{{ $t("message.IssueDate") }} : {{ ChangeFormatDate(startDate) }}</div>
              <div class="qr-date">{{ $t("message.ExpiryDate") }} : {{ ChangeFormatDate(endDate) }}</div>
              <div class="qr-note">{{ $t("message.Onetime") }}</div>
            </v-card>

            <v-card v-if="!show" elevation="0" class="qr-message">
              {{ "*" + message }}
            </v-card>
          </section>

          <div class="print-actions">
            <v-btn color="#344054" class="box white--text text-capitalize print-action-btn" router
              @click="BacktoNationalIDCard()">
              {{ $t("message.Back") }}
            </v-btn>
          </div>
        </v-card>
      </v-container>
    </v-sheet>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import html2canvas from "html2canvas";
// import logoimage from "@/assets/OneBangkokLogo.png";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "CapturePerson",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      ResponsePassport: [],
      ResponseSmartCard: [],
      isPhotoTaken: false,
      download: false,
      PictureName: "PersonID.jpg",
      startDate: "",
      endDate: "",
      Qrcode: "https://www.onebangkok.com/th/",
      tenantName: "One Bangkok",
      floorName: "1",
      zoneName: "",
      data: [],
      show: true,
      message: "",
      logoimage: "",
    };
  },


  mounted: function () {
    let self = this;
    self.logoimage = require("@/assets/OneBangkokLogo.png");
    // self.createCameraElement();
    var s = new Date();
    self.startDate = s;
    self.endDate = s;
    // console.log(self.$route.params.data);
    self.data = self.$route.params.data;
    self.floorName = self.data.floorID;
    self.zoneName = self.$route.params.zoneName;
    self.tenantName = self.$route.params.tenantName;
    self.addDataVisitor();
 
  },

  methods: {
    addDataVisitor() {
      let self = this;
      // self.LoadingDialog = true;


      let temp = self.data;


      axios
        .post(`${self.url}VMS/addDataVisitor`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            console.log(response.data.data);
            let temp = localStorage.getItem("LogId");
            if (temp != "") {
              self.show = false;
              self.message = "Successfully";
            } else {
              var s = new Date();
              self.startDate = s;
              let dateOut = response.data.data.split('"')[7].replace("Z", "");

              self.endDate = dateOut;
              self.Qrcode = response.data.data;
              self.show = true;
            }
          }
          if (response.data.status == 1) {
            self.show = false;
            self.message = response.data.message;
          }
        })
        .catch(function () { });
    },
    print() {
      let self = this;
      html2canvas(document.querySelector("#capture")).then((canvas) => {
        const base64 = canvas.toDataURL("image/png");

        var tWindow = window.open("");

        tWindow.document.body.appendChild(canvas);

        tWindow.focus();

        tWindow.print();

        tWindow.close();

        self.base64 = base64;

        self.GotoMainPage();

        // self.ReSet();
      });
    },
    ReSet() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      // var ampm = hours >= 12 ? "PM" : "AM";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var month = DateData.getMonth() + 1;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        month +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    GotoMainPage() {
      let self = this;
      // location.reload();
      // localStorage.setItem("refresh", '');
      self.$router.push("/MainMenu");
    },

    BacktoNationalIDCard() {
      let self = this;

      // self.$router.push("/NationalIDCard");
      self.$router.push("/MainMenu");
      // self.$router.push("/FindingTenant");
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
.print-qr-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(12px, 1.7vh, 22px);
  padding: clamp(16px, 2.6vw, 36px);
}

.print-qr-page .print-logo {
  width: min(28vw, 430px) !important;
  max-width: min(28vw, 430px) !important;
  margin: 0 !important;
}

.print-qr-page .print-panel {
  width: min(1080px, calc(100vw - 150px)) !important;
  min-height: 0 !important;
  max-height: calc(100vh - 150px);
  margin: 0 auto !important;
  padding: clamp(16px, 2vw, 30px) !important;
}

.print-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(10px, 1.3vh, 18px);
}

.print-header {
  text-align: center;
}

.print-header h1 {
  color: #344054;
  font-size: clamp(34px, 3.1vw, 56px);
  font-weight: 900;
  line-height: 1.05;
  margin: 0;
}

.print-header p {
  color: #667085;
  font-size: clamp(20px, 1.8vw, 32px);
  font-weight: 800;
  line-height: 1.2;
  margin: 8px 0 0;
}

.print-header span {
  display: block;
  color: #344054;
  font-size: clamp(16px, 1.1vw, 20px);
  font-weight: 900;
  margin-top: 10px;
}

.print-divider {
  width: min(520px, 44vw);
  margin: 12px auto 0;
  border-top-width: 7px !important;
  border-color: #344054 !important;
}

.qr-stage {
  display: flex;
  justify-content: center;
  width: 100%;
}

.qr-ticket {
  width: min(520px, 100%);
  min-height: 0;
  padding: clamp(12px, 1.5vh, 18px) clamp(18px, 2vw, 28px);
  background-color: #ffffff !important;
  border: 1px solid rgba(52, 64, 84, 0.12);
  border-radius: 10px;
  box-shadow:
    0 14px 28px rgba(16, 24, 40, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  text-align: center;
}

.qr-tenant {
  color: #1f2937;
  font-size: clamp(24px, 2vw, 34px);
  font-weight: 800;
  line-height: 1.1;
}

.qr-floor {
  color: #1f2937;
  font-size: clamp(20px, 1.55vw, 28px);
  font-weight: 800;
  line-height: 1.1;
  margin-top: 8px;
}

.qr-code-wrap {
  display: flex;
  justify-content: center;
  margin: clamp(8px, 1.3vh, 14px) 0;
}

.qr-date {
  color: #1f2937;
  font-size: clamp(16px, 1.15vw, 22px);
  font-weight: 800;
  line-height: 1.25;
  margin-top: 5px;
}

.qr-note {
  color: #344054;
  font-size: clamp(13px, 0.95vw, 17px);
  font-weight: 800;
  line-height: 1.25;
  margin-top: 6px;
}

.qr-message {
  width: min(520px, 100%);
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #ffffff !important;
  color: #d92d20;
  font-size: clamp(30px, 3vw, 50px);
  font-weight: 900;
  text-align: center;
}

.print-actions {
  width: min(420px, 100%);
  margin: 0 auto;
}

.print-action-btn {
  width: 100% !important;
  min-height: 82px !important;
  font-size: clamp(30px, 2.6vw, 44px) !important;
  font-weight: 900 !important;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
